// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1bmUQ","select":"Header_select__bc8SJ","clinic":"Header_clinic__8FT5K"};